import { InstitucionalAffidavitI } from '../domain/InsitucionalAffidavit';
import { AffidavitBusinessFinalBeneficiary } from '../domain/AffidavitFinalBeneficiaryBusiness';
import ComplianceRepositoryI from '../repository/ComplianceRepositoryI';
import ComplianceServiceI from './ComplianceServiceI';

export default class ComplianceServiceImpl implements ComplianceServiceI {
  constructor(private repository: ComplianceRepositoryI) {}

  getPendingAffidavitsWithUrlByCustomerId(
    customerId: string,
  ): Promise<InstitucionalAffidavitI[]> {
    return this.repository.getPendingAffidavitsWithUrlByCustomerId(customerId);
  }

  async createBusinessAffidavit(
    customerId: string,
    data: AffidavitBusinessFinalBeneficiary,
  ): Promise<void> {
    return this.repository.createBusinessAffidavit(customerId, data);
  }

  async generatePreviewBusinessAffidavit(
    customerId: string,
    data: AffidavitBusinessFinalBeneficiary,
  ): Promise<any> {
    return this.repository.generatePreviewBusinessAffidavit(customerId, data);
  }
}
